import * as React from "react";
import { Grid, Button, Box, Typography } from "@mui/material";
import Cookies from "js-cookie";

const LogoutContent = () => {
  // ✅ Attempt to read the user name from cookie (if still available before removal)
  const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

  return (
    <Box
      className="auth-main-wrapper logout-area"
      sx={{
        py: { xs: "60px", md: "80px", lg: "100px", xl: "135px" },
      }}
    >
      <Box
        sx={{
          maxWidth: { sm: "500px", md: "1255px" },
          mx: "auto !important",
          px: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          columnSpacing={{ xs: 1, sm: 2, md: 4, lg: 3 }}
        >
          {/* Left: Image */}
          <Grid item xs={12} md={6} lg={6} xl={7}>
            <Box
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              <img
                src="/images/logout.jpg"
                alt="logout"
                width="100%"
                height="auto"
                style={{
                  borderRadius: "24px",
                  maxHeight: "80vh",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>

          {/* Right: Logout Message */}
          <Grid item xs={12} md={6} lg={6} xl={5}>
            <Box
              className="form-content"
              sx={{
                paddingLeft: { xs: "0", lg: "10px" },
              }}
            >
              {/* Logo */}
              {/* <Box className="logo" sx={{ mb: "23px" }}>
                <img
                  src="/images/logo-big.svg"
                  alt="logo"
                  width={142}
                  height={38}
                />
              </Box> */}

              {/* Title */}
              <Box className="title" sx={{ mb: "23px" }}>
                <Typography
                  variant="h1"
                  className="text-black"
                  sx={{
                    fontSize: { xs: "22px", sm: "25px", lg: "28px" },
                    mb: "10px",
                    fontWeight: "600",
                  }}
                >
                  You’ve been securely logged out
                </Typography>

                <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                  {user?.userName
                    ? `Goodbye, ${user.userName}. See you soon!`
                    : "See you soon!"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  mb: "20px",
                }}
              >
                <img
                  src="/images/admin.png"
                  className="rounded-circle"
                  alt="admin"
                  width={50}
                  height={50}
                />
                <Typography
                  component="span"
                  className="text-black"
                  sx={{
                    fontWeight: "600",
                    display: "block",
                  }}
                >
                  {user?.userName || "Patient User"}
                </Typography>
              </Box>

              {/* Button to login again (in case navigation was blocked) */}
              <Button
                href="/authentication/sign-in/"
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "6px",
                  fontWeight: "500",
                  fontSize: { xs: "13px", sm: "16px" },
                  padding: { xs: "10px 20px", sm: "10px 24px" },
                  color: "#fff !important",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <i className="material-symbols-outlined mr-5">login</i>
                Sign In Again
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default LogoutContent;